
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { formatUploadSize, uploadStatusLabel } from './upload-progress-labels';
import type { UploadProgressLine } from './upload-progress.types';

export type { UploadItemStatus, UploadProgressLine } from './upload-progress.types';

@Component({
  selector: 'app-upload-progress-tracker',
  standalone: true,
  imports: [],
  templateUrl: './upload-progress-tracker.component.html',
  styleUrls: ['./upload-progress-tracker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadProgressTrackerComponent {
  readonly items = input<UploadProgressLine[]>([]);

  formatSize(bytes: number): string {
    return formatUploadSize(bytes);
  }

  statusLabel(s: Parameters<typeof uploadStatusLabel>[0]): string {
    return uploadStatusLabel(s);
  }
}
